var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-section-wrap',{attrs:{"modifier":'login --terms'}},[_c('div',{staticClass:"card",attrs:{"column":"xs-12 s-12 m-8 +m-2"}},[_c('div',[_c('h1',[_vm._v("Thank you for visiting EyeMed Client Portal. Your session has ended.")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }